export enum TrackingSourceEnum {
  Google = 1,
  Direct = 2,
  Newsletter = 3,
  Bing = 4,
  Content = 5,
  Adstraction = 6,
  Affiliates = 7,
  Online = 9,
  Programmatics = 11,
  Snapchat = 13,
  Tiktok = 12,
  Facebook = 10,
  Influencer = 17,
}
